import validate from 'validator';

const validator = {
  isValidEmail (email) {
    return validate.isEmail(email);
  },
  isUSPhoneNumber (phone) {
    if (!phone) {
      return false;
    }
    let plus = '+';
    let phoneFormatted = phone.replace(/[^0-9]/g, '');
    phoneFormatted = plus.concat(phoneFormatted);
    return validate.isMobilePhone(phoneFormatted, ['en-US']);
  },
  validateAge (age, dateStr) {
    if (!dateStr || dateStr.length !== 10) { // MM/DD/YYYY
      return false;
    }
    let date = new Date(dateStr);
    if (date) {
      let currentAge = new Date().getYear() - date.getYear();
      return currentAge > age;
    }
    return false;
  },
  isPasswordValid (password) {
    const rulesCheck = {
      lowerCaseChars: [],
      upperCaseChars: [],
      numbers: []
    };
    for (let i = 0; i < password.length; i++) {
      let chrCode = password.charCodeAt(i);
      if (chrCode > 64 && chrCode < 91) {
        rulesCheck.upperCaseChars.push(password[i]);
      }
      if (chrCode > 96 && chrCode < 123) {
        rulesCheck.lowerCaseChars.push(password[i]);
      }
      if (chrCode > 47 && chrCode < 58) {
        rulesCheck.numbers.push(password[i]);
      }
    }
    let summary = rulesCheck.lowerCaseChars.length >= 4 &&
      rulesCheck.upperCaseChars.length >= 1 &&
      rulesCheck.numbers.length >= 2 &&
      validator.isHasSpecialCase(password) &&
      password.length >= 8;
    let result = {
      summary: summary,
      detail: {
        length: password.length >= 8,
        lowerCaseChars: rulesCheck.lowerCaseChars.length >= 4,
        upperCaseChars: rulesCheck.upperCaseChars.length >= 1,
        numbers: rulesCheck.numbers.length >= 2,
        specialChars: validator.isHasSpecialCase(password)
      }
    };
    return result;
  },
  isHasSpecialCase (password) {
    let specialChars = '<>@!#$%^&*()_+[]{}?:;|\'"\\,./~`-=';
    for (let i = 0; i < specialChars.length; i++) {
      if (password.indexOf(specialChars[i]) > -1) {
        return true;
      }
    }
    return false;
  },
  isValidUrl (url) {
    return validate.isURL(url);
  },
  isValidImageUrl (url) {
    return (url.match(/\.(jpeg|jpg|gif|png)$/) != null) || url.indexOf('data:image') > -1;
  }

};

export default validator;



// WEBPACK FOOTER //
// ./src/utils/validator.js